module.exports = __webpack_public_path__ + "img/apple-touch-icon-114x114.d04066da.png";